<template>
  <div class="complete-modal-page-wrapper">
    <div class="complete-modal-page">
      <div id="loading-spinner-wrapper" v-if="state.show_loader">
        <img :src="BASE_URL+'static/images/loading-spinner.svg'" class="loading-spinner">
      </div>
      <div class="button-area">
        <ion-button id="test_confim_back_button" @click="dismiss()" :disabled="buttonDisabled">{{
            state.language_set.link_go_back
          }}
        </ion-button>

        <ion-button id="test_confirm_finish" class="finish-button" :disabled="buttonDisabled"
                    style="margin-right:10px; margin-left:10px"
                    @click="completeTest()">
          {{ state.language_set.link_confirm_finish }}
        </ion-button>

      </div>
    </div>
  </div>
</template>

<script>
import {IonButton, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar} from '@ionic/vue';
import {computed, defineComponent, onMounted, reactive} from 'vue';
import store from "@/store";

export default defineComponent({
  name: 'CompleteTestModal',
  components: {IonContent, IonHeader, IonTitle, IonToolbar, IonPage, IonButton, IonIcon},
  props: {
    isButtonDisabled: {
      type: Boolean,
    }
  },
  setup(props, ctx) {
    const BASE_URL = process.env.BASE_URL;
    const state = reactive({
      language_set: store.getters.languageSet,
      show_loader: false
    });

    function dismiss() {
      state.show_loader = false;
      ctx.emit('dismiss-compete-test-modal');
    }

    function completeTest() {
      ctx.emit('complete-test');
      state.show_loader = true;
    }

    const buttonDisabled = computed(() => {
      return props.isButtonDisabled;
    })

    onMounted(() => {
      setTimeout(() => {
        let finish_button = document.querySelector('#test_confirm_finish');
        let inner_button = finish_button.shadowRoot.querySelector('button');
        inner_button.focus();
      }, 500)

    })


    return {state, dismiss, completeTest, buttonDisabled, BASE_URL}
  }
});
</script>

<style lang="scss" scoped>


.complete-modal-page {
  left: inherit;
  right: inherit;
  top: inherit;
  bottom: inherit;
  position: relative;
  contain: inherit;
  justify-content: center;
  height: 172px;
  display: flex;
  flex-direction: column;


}

.button-area {
  width: 100%;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  height: 38px;
  margin-top: 0px;
  margin-bottom: 0px;
  display: table-cell !important;
  vertical-align: middle;
  padding: 0 10px;
  text-align: center;
  align-self: center;
}

.button-area .button {
  margin: 0 20px;
}

ion-header {
  padding: 24px 0px 24px 32px;
  border-bottom: 1px solid variables.$color-gray-02;
  height: 68px;
  font-size: 20px;
}

.icon.close-button {
  position: absolute;
  top: 26px;
  right: 32px;
  cursor: pointer;
}

.modal-content {
  padding-left: 32px;
  padding-right: 27px;
  margin-top: 41px;
  margin-bottom: 52px;
}

#back-button {
  --background: variables.$color-white;
  border: 1px solid variables.$color-gray-02;
  border-radius: 4px;
  color: variables.$text-color-primary;
}

@media only screen and (min-width: 768px) and (min-height: 768px) {
  .sc-ion-modal-md-h {
    width: auto
  }
}

@media only screen and (max-width: 768px) {
  .button-area .button {
    margin: 10px;
  }
}

@media only screen and (min-width: 768px){
  .complete-modal-page-wrapper{
    display: flex;
    align-self: center;
    justify-self: center;
    background-color: rgba(0, 0, 0, 0.3);
    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
  }

  .complete-modal-page{
    height: 172px;
    border-radius: 5px;
    min-width: 400px;
    background-color: white;
    width: auto;
    box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
  }


}
#loading-spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 41px;
  margin-bottom: 20px;


  .loading-spinner {
    height: 40px;
  }
}
</style>
